<div class="personalise-wrapper">
  <app-content-notification
    *ngIf="!(flipperBrokenPf$ | async)?.attributes.value && showPortfolioUndoMessage"
    [showUndoMessage]="showPortfolioUndoMessage"
    [type]="'success'"
    [messages]="['brokenPrevention.messageReverted' | translate]"
  ></app-content-notification>

  <ng-container *ngIf="!(flipperBrokenPf$ | async)?.attributes.value && showPortfolioWarningBox">
    <div class="info-message">
      <div class="info-message-icon">
        <span class="icon-i-info"></span>
      </div>
      <div class="info-message-text">
        <p>
          <span [innerHTML]="'brokenPrevention.messageUnblock.message' | translate"></span>&nbsp;
          <a (click)="onShowExcludedCompanies()">{{ 'brokenPrevention.messageUnblock.link' | translate }}</a>
        </p>
      </div>
    </div>
  </ng-container>
  <div class="strategy-header">
    <div>
      <span
        >{{ 'new_strategy.navigation.step' | translate }} {{ is3aPillar ? 3 : 4 }}
        {{ 'new_strategy.navigation.optional' | translate }}</span
      >
      <h1 class="ui-headline">{{ 'new_strategy.matches_screen_b.h2' | translate }}</h1>
      <p class="personalise-subtitle">
        <span class="icon-i-heart"></span><span [innerHTML]="'new_strategy.matches_screen_b.favourite' | translate"></span>
      </p>
      <p class="personalise-subtitle">
        <span class="icon-i-blocked"></span><span [innerHTML]="'new_strategy.matches_screen_b.blocked' | translate"></span>
      </p>
      <p [innerHTML]="'new_strategy.matches_screen_b.p' | translate"></p>
      <p *ngIf="customer.app_location !== 'ch'" class="ui-caption">
        {{ 'new_strategy.matches_screen_b.legalNotice' | translate }}
      </p>

      <div class="personalise-guidance-button">
        <button type="button" class="ui-button-text" (click)="onOpenGuidance()">
          <span>{{ 'walkthrough.personalisation.CTA.reopen' | translate }}</span
          ><span class="icon-i-info"></span>
        </button>
      </div>
    </div>
  </div>

  <div class="ui-section-tabs-container">
    <div class="ui-section-tabs">
      <div
        class="ui-section-tab"
        tabindex="0"
        [class.active]="showTab === personaliseTabs.PORTFOLIO"
        (keyup.enter)="switchTab(personaliseTabs.PORTFOLIO)"
        (click)="switchTab(personaliseTabs.PORTFOLIO)"
      >
        <div>
          <p>
            {{ 'new_strategy.matches_screen_b.tab1' | translate }}
          </p>
        </div>
      </div>
      <div
        class="ui-section-tab"
        tabindex="0"
        [class.active]="showTab === personaliseTabs.RECOMMENDATIONS"
        (keyup.enter)="switchTab(personaliseTabs.RECOMMENDATIONS)"
        (click)="switchTab(personaliseTabs.RECOMMENDATIONS)"
      >
        <div>
          <p>
            {{ 'new_strategy.matches_screen_b.tab3' | translate }}
          </p>
        </div>
      </div>
      <div
        class="ui-section-tab"
        tabindex="0"
        [class.active]="showTab === personaliseTabs.SEARCH"
        (keyup.enter)="switchTab(personaliseTabs.SEARCH)"
        (click)="switchTab(personaliseTabs.SEARCH)"
      >
        <div>
          <p>
            <span class="icon-i-search"></span>
          </p>
        </div>
      </div>
    </div>
    <div *ngIf="!companiesLoaded; else listholder">
      <div *ngFor="let load of [].constructor(10)" class="skeleton-wrapper">
        <div class="title-holder">
          <div class="title skeleton"></div>
          <div class="img skeleton"></div>
        </div>
        <div class="button skeleton"></div>
      </div>
    </div>
    <ng-template #listholder>
      <div class="personalise-tab-list">
        <div class="personalise-tab-item" [class.active]="showTab === personaliseTabs.PORTFOLIO">
          <app-strategy-company-list
            [activeTab]="showTab"
            [appLocation]="customer.app_location"
            [companyList]="wishlistCompanies"
            [listType]="'wishlist'"
            [loadingID]="loadingID"
            (updateLoadingID)="loadingID = $event"
            (updateCompanyDetail)="updateCompanyDetail($event, portfolioWishDetail)"
            (showWhyInyova)="showStabilityModal = $event"
          >
            <div #portfolioWishDetail>
              <app-company-detail
                *ngIf="showCompanyDetail"
                [appLocation]="customer.app_location"
                [loadingID]="loadingID"
                [showActions]="false"
                [activeTab]="showTab"
              ></app-company-detail>
            </div>
          </app-strategy-company-list>
          <app-strategy-company-list
            [activeTab]="showTab"
            [appLocation]="customer.app_location"
            [companyList]="portfolioStocks"
            [loadingID]="loadingID"
            (updateLoadingID)="loadingID = $event"
            (updateCompanyDetail)="updateCompanyDetail($event, portfolioStockDetail)"
            (showWhyInyova)="showStabilityModal = $event"
          >
            <div #portfolioStockDetail>
              <app-company-detail
                *ngIf="showCompanyDetail"
                [appLocation]="customer.app_location"
                [loadingID]="loadingID"
                [showActions]="false"
                [activeTab]="showTab"
              ></app-company-detail>
            </div>
          </app-strategy-company-list>

          <div class="personalise-excluded" #excludedDetail>
            <button class="ui-button-text" (click)="toggleExcludedCompanies()">
              <span>{{ 'new_strategy.matches_screen_b.show_blacklisted' | translate }}</span>
              <span class="icon-i-chevron-down" [class.rotate]="showExcludedCompanies"></span>
            </button>

            <div [@collapse]="!showExcludedCompanies">
              <ng-container *ngIf="blockedCompanies?.length">
                <app-strategy-company-list
                  [activeTab]="showTab"
                  [appLocation]="customer.app_location"
                  [companyList]="blockedCompanies"
                  [listType]="'blocked'"
                  [loadingID]="loadingID"
                  [blockedCompaniesIDs]="blockedCompaniesIDs"
                  (updateLoadingID)="loadingID = $event"
                  (updateCompanyDetail)="updateCompanyDetail($event, blockDetail)"
                  (showWhyInyova)="showStabilityModal = $event"
                >
                  <div #blockDetail>
                    <app-company-detail
                      *ngIf="showCompanyDetail"
                      [appLocation]="customer.app_location"
                      [loadingID]="loadingID"
                      [showActions]="false"
                      [activeTab]="showTab"
                    ></app-company-detail>
                  </div>
                </app-strategy-company-list>
              </ng-container>
              <div class="list-info white" *ngIf="blockedCompanies?.length === 0">
                <p>{{ 'new_strategy.matches_screen_b.missing_black' | translate }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="personalise-tab-item" [class.active]="showTab === personaliseTabs.RECOMMENDATIONS">
          <ng-container *ngIf="inyovaStocksCompanies?.length; else noSuggestions">
            <div class="recommendations">
              <div class="recommendations-img">
                <img src="/assets/images/recommendationsB.jpg" />
              </div>
              <div class="recommendations-content">
                <h2 class="ui-headline">{{ 'new_strategy.matches_screen_b.suggestion_topWL.title' | translate }}</h2>
                <p>{{ 'new_strategy.matches_screen_b.suggestion_topWL.p' | translate }}</p>
              </div>
            </div>
          </ng-container>
          <ng-template #noSuggestions>
            <div class="recommendations">
              <div class="recommendations-img">
                <img src="/assets/images/recommendationsC.jpg" />
              </div>
              <div class="recommendations-content">
                <h2 class="ui-headline">{{ 'new_strategy.matches_screen_b.no_suggestion.title' | translate }}</h2>
                <p>{{ 'new_strategy.matches_screen_b.no_suggestion.p' | translate }}</p>
              </div>
            </div>
          </ng-template>

          <app-strategy-company-list
            [activeTab]="showTab"
            [appLocation]="customer.app_location"
            [listType]="'mixed'"
            [wishedCompaniesIDs]="wishedCompaniesIDs"
            [blockedCompaniesIDs]="blockedCompaniesIDs"
            [companyList]="inyovaStocksCompanies | slice: 0:suggestedCount"
            [loadingID]="loadingID"
            (updateLoadingID)="loadingID = $event"
            (updateCompanyDetail)="updateCompanyDetail($event, recommendedDetail)"
            (showWhyInyova)="showStabilityModal = $event"
          >
            <div #recommendedDetail>
              <app-company-detail
                *ngIf="showCompanyDetail"
                [appLocation]="customer.app_location"
                [loadingID]="loadingID"
                [showActions]="false"
                [activeTab]="showTab"
              ></app-company-detail>
            </div>
          </app-strategy-company-list>
          <a
            *ngIf="inyovaStocksCompanies?.length > 5"
            class="show-more"
            (click)="suggestedCount === 5 ? (suggestedCount = 10) : (suggestedCount = 5)"
          >
            {{ (suggestedCount === 5 ? 'performance.table.show_more' : 'performance.table.show_less') | translate }}
          </a>
        </div>

        <div class="personalise-tab-item" [class.active]="showTab === personaliseTabs.SEARCH">
          <div class="company-search">
            <img class="company-search-icon" src="/assets/images/search.svg" alt="icon search" width="18px" height="18px" />
            <input
              #searchInput
              class="company-search-input"
              type="text"
              name="search"
              [placeholder]="'new_strategy.matches_screen_b.search' | translate"
              (keydown)="searchCompany()"
            />
            <img
              *ngIf="isSearched"
              class="company-search-close"
              src="/assets/images/mini-close.svg"
              alt="icon search"
              width="12px"
              height="12px"
              (click)="clearSearch()"
            />
          </div>
          <ng-container *ngIf="!searchResultCompaniesLoading; else searchResultLoading">
            <app-strategy-company-list
              [activeTab]="showTab"
              [appLocation]="customer.app_location"
              [listType]="'mixed'"
              [wishedCompaniesIDs]="wishedCompaniesIDs"
              [blockedCompaniesIDs]="blockedCompaniesIDs"
              [companyList]="searchResultCompanies"
              [loadingID]="loadingID"
              (updateLoadingID)="loadingID = $event"
              (updateCompanyDetail)="updateCompanyDetail($event, searchDetail)"
              (showWhyInyova)="showStabilityModal = $event"
            >
              <div #searchDetail>
                <app-company-detail
                  *ngIf="showCompanyDetail"
                  [appLocation]="customer.app_location"
                  [loadingID]="loadingID"
                  [showActions]="false"
                  [activeTab]="showTab"
                ></app-company-detail>
              </div>
            </app-strategy-company-list>
            <div class="company-list-empty" *ngIf="isSearched && !searchResultCompanies.length">
              <p>{{ 'wishlist.noResult.p1' | translate }}</p>
              <div class="company-detail-empty" *ngIf="showEmptyState">
                <lottie-player src="/assets/lottiefiles/wind-turbine.json" background="transparent" speed="1" loop autoplay></lottie-player>
              </div>
              <p>
                <b>{{ 'wishlist.noResult.reasons.p1' | translate }}</b>
              </p>
              <ul>
                <li>{{ 'wishlist.noResult.reasons.p2' | translate }}</li>
                <li>{{ 'wishlist.noResult.reasons.p3' | translate }}</li>
                <li>{{ 'wishlist.noResult.reasons.p4' | translate }}</li>
              </ul>
              <div class="suggestion-sent" *ngIf="suggestionSent">
                <i class="icon-i-checkmark-circle"></i>
                {{ 'wishlist.noResult.suggest.success' | translate }}
              </div>
              <button class="ui-button secondary" (click)="suggestCompany(searchInput.value)" *ngIf="!suggestionSent">
                {{ 'wishlist.noResult.suggest.CTA' | translate: { searchEntry: '"' + searchInput.value + '"' } }}
              </button>
            </div>
          </ng-container>
          <ng-template #searchResultLoading>
            <div class="skeleton-wrapper">
              <div class="title-holder">
                <div class="title skeleton"></div>
                <div class="img skeleton"></div>
              </div>
              <div class="button skeleton"></div>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-template>
    <div *ngIf="activeGuidance" class="personalise-guidance-target"></div>
  </div>
</div>

<app-footer [hideGuarantee]="false">
  <div class="personalise-action-target" [class.personalise-guidance-active]="activeGuidance">
    <button (click)="backToStrategy()" class="ui-button" readonly [class.loading]="isLoading" [disabled]="isLoading">
      <span class="icon-i-windmill"></span>
      {{ 'new_strategy.portfolio_screen.go_cta' | translate }}
    </button>
  </div>
</app-footer>

<app-dialog-stability *ngIf="showStabilityModal" (showWhyInyova)="showStabilityModal = $event"></app-dialog-stability>
